<script>
    import R, {LOADER} from "../../lib/requests";
    import user from "../../stores/user";
    import Alert from "../../stores/alerts";
    import Notifier from "../../stores/notifier";
    import {copyObjectProperties, sort} from "../../lib/lib";
    import PageHeader from "../../components/PageHeader.svelte";
    import TableHeader from "../../components/TableHeader.svelte";
    import AppIcon from "../../components/icons/AppIcon.svelte";
    import AnalysisEditModal from "./AnalysisEditModal.svelte";


    let list = null;
    let filtered = null;
    let selectedId = 0;
    let editId = null;
    let term = '';

    const pageHeaderControls = [
        {id: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ ΑΝΑΛΥΣΗΣ', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'code', title: 'ΚΩΔΙΚΟΣ', sortable: true, sort_way: 'ASC'},
        {key: 'name_el', title: 'ΑΝΑΛ. ΠΑΡΑΜΕΤΡΟΣ', sortable: true},
        {key: 'method', title: 'ΜΕΘΟΔΟΛΟΓΙΑ', sortable: true},
        {key: 'units', title: 'ΜΟΝΑΔΕΣ', sortable: true, class: 'hidden-xs'},
        {key: 'material_category', title: 'ΚΑΤ. ΥΛΙΚΟΥ', sortable: true, class: 'hidden-xs'},
        {key: 'material', title: 'ΕΞΕΤ. ΥΛΙΚΟ', sortable: true, class: 'hidden-xs'},
        {key: 'upper_limits', title: 'ΑΝΩΤΑΤΑ ΟΡΙΑ', sortable: true, class: 'hidden-xs'},
        {key: 'indicative_limits', title: 'ΕΝΔΕΙΚΤ. ΟΡΙΑ', sortable: true, class: 'hidden-xs'},
        {key: 'legislation', title: 'ΝΟΜΟΘΕΣΙΑ', sortable: true, class: 'hidden-xs'},
        {key: '', title: '', hidden: !user.isAdmin()},
    ];

    const load = () => {
        const onSuccess = result => {
            list = result;
            list.map(item => {
                if (!item.name_el) {
                    item.name_el = "----";
                }
            });
            filtered = list;
        }

        const onFailure = err => {
        };

        R.handle(R.analyses.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const filterList = () => {
        if (list == null) {
            return;
        }

        let t = term.toLowerCase().trimStart();
        if (t.length > 0) {
            filtered = list.filter(item => {
                return (
                    item.code?.toLowerCase().includes(t) ||
                    item.name_el?.toLowerCase().includes(t) ||
                    item.material?.toLowerCase().includes(t)
                );
            });
        }
    }

    const onColumnSort = ({detail}) => {
        list = sort(list, detail.key, detail.sort_way === 'DESC');
    }

    const onCreate = () => {
        editId = 0;
    }

    const onEdit = (user) => {
        selectedId = user.id;
        editId = user.id;
    }

    const closeEdit = (analysis) => {
        if (analysis) {
            if (!analysis.name_el) {
                analysis.name_el = "----";
            }
            let properties = ['id', 'code', 'name_el', 'name_en', 'method', 'units', 'material_category', 'material', 'upper_limits', 'indicative_limits', 'comments', 'legislation'];

            let item = list.find(x => x.id == analysis.id);
            if (item) {
                copyObjectProperties(analysis, item, properties);
                list = list;
            } else {
                list = [copyObjectProperties(analysis, properties), ...list];
            }
            filterList();
        }
        editId = null;
    }

    const onDelete = (item) => {
        Alert.delete("Διαγραφή ανάλυσης", `Πρόκειται να διαγράψετε την ανάλυση "${item.name_el}".\nΘέλετε να συνεχίσετε;`, () => deleteItem(item.id));
    }

    const deleteItem = id => {
        const onSuccess = result => {
            list = list.filter(x => x.id != result);
            filterList();
            Notifier.showMessage("Η ανάλυση διαγράφτηκε");
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                Alert.warning("Διαγραφή ανάλυσης", `Δεν μπορείτε να διαγράψετε αυτή την ανάλυση γιατί είναι συσχετισμένη με ${err.params.samples} δείγματα.`);
            }
        };

        R.handle(R.analyses.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();

    $: filterList(term);
</script>

<PageHeader title="Αναλύσεις" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

<div class="panel-simple p-2 mb-4">
    <input type="text" class="form-control" bind:value={term} placeholder="κωδικός, όνομα ανάλυσης ή υλικό">
</div>

{#if filtered != null}
    <div class="panel">
        <div class="panel-body">
            {#if filtered.length > 0}
                <table class="table table-list analyses-list table-list-border">
                    <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                    <tbody>
                    {#each filtered as item}
                        <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                            <td class="code">
                                { item.code }
                            </td>
                            <td>
                                <div class="is-link"
                                     on:click="{ () => onEdit(item) }">
                                    { item.name_el }
                                </div>
                                {#if item.name_en}
                                    <div class="small">
                                        { item.name_en }
                                    </div>
                                {/if}
                            </td>
                            <td class="text-gray">
                                { item.method }
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.units }
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.material_category }
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.material }
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.upper_limits }
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.indicative_limits }
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.legislation }
                            </td>
                            {#if user.isAdmin()}
                                <td class="button-column pointer" title="διαγραφή ανάλυσης"
                                    on:click="{ () => onDelete(item) }">
                                    <AppIcon icon="trash" size="16"/>
                                </td>
                            {/if}
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {:else}
                <div class="panel-simple p-2">
                    Δεν βρέθηκαν αναλύσεις!
                </div>
            {/if}
        </div>
    </div>
{/if}
{#if editId != null}
    <AnalysisEditModal analysisId="{ editId }" closeCallback="{ closeEdit }"/>
{/if}

<style>
    .analyses-list .code {
        width: 60px;
    }

    .panel-filters {
        background: #fff;
        border: var(--default-border);
    }

    .panel-filters .filter-row {
        display: flex;
    }

    .panel-filters .filter-col-group {
        display: flex;
        width: 100%;
    }

    .panel-filters .filter-col {
        padding: 5px 10px;
    }

    .panel-filters .filter-col.user-name {
        width: 100%;
    }

    @media (max-width: 576px) {
        .panel-filters .filter-row {
            display: block;
        }

        .panel-filters .filter-col.border-after:after {
            border: none;
        }
    }
</style>